import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

import LottieAnimationWrapper from "components/Shared/Lottie/LottieAnimationWrapper";

import NotFound from "assets/lottie/404.json";

export const NotFoundScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-12">
      <LottieAnimationWrapper lottieFile={NotFound} height={300} />

      <div className="flex flex-col items-center gap-4">
        <p>Ops! The page you're looking for doesn't exist.</p>

        <Button onClick={() => navigate("/")}>Go Home</Button>
      </div>
    </div>
  );
};

export default NotFoundScreen;
